import { strategyToOptions } from "@/common/utils/strategyToOptions"

export const eventableStatus = {
  pending: 'Pendente',
  confirmed: 'Confirmado',
}

export const eventableStatusOptions = strategyToOptions(eventableStatus);
